type VimeoAction =
  | "play"
  | "pause"
  | "unload"
  | "seekTo"
  | "addEventListener"
  | "removeEventListener"

export const postMessageToVimeo = (
  targetWindow: HTMLIFrameElement,
  action: VimeoAction,
  value?: number | string,
) => {
  const data: { method: VimeoAction; value?: number | string } = {
    method: action,
  }

  if (value !== undefined) {
    data.value = value
  }

  const message = JSON.stringify(data)
  targetWindow.contentWindow?.postMessage(message, "https://player.vimeo.com") // Always specify the origin
}
